import { useEffect } from 'react';
import { installAutoTitles } from './autoTitle';

/** Ставится один раз на всё приложение — см. autoTitle.ts. */
export function useAutoTitles(): void {
  useEffect(() => installAutoTitles(), []);
}
